import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ModalBaseComponent } from 'app/shared/components/base/modal-base/modal-base.component';
import { Url } from 'app/shared/constants/url';
import { Bank } from 'app/shared/models/bank.model';
import { CompanyBank } from 'app/shared/models/company-bank.model';
import { GenericService } from 'app/shared/services/generic.service';

@Component({
  selector: 'app-company-bank',
  templateUrl: './company-bank.component.html',
  styleUrls: ['./company-bank.component.scss']
})

export class CompanyBankComponent extends ModalBaseComponent implements OnInit {

  @Input() companyId: number;

  addedSuccessfullyMessage: string;
  updatedSuccessfullyMessage: string;
  isDeletedMessage: string;
  private consentUrlGeneratedSuccessfullyMessage: string;
  isEditMode = false;

  constructor(
    protected genericService: GenericService,
    protected activeModal: NgbActiveModal,
    protected modalService: NgbModal,
    protected translateService: TranslateService) {
    super(activeModal);
  }

  ngOnInit(): void {
    this.initializeObject();
    this.translateService.get(['companyBank.addedSuccessfullyMessage', 'companyBank.updatedSuccessfullyMessage', 'companyBank.isDeletedMessage',
      'companyBank.consentUrlGeneratedSuccessfullyMessage'])
      .subscribe(translations => {
        this.addedSuccessfullyMessage = translations['companyBank.addedSuccessfullyMessage'];
        this.updatedSuccessfullyMessage = translations['companyBank.updatedSuccessfullyMessage'];
        this.isDeletedMessage = translations['companyBank.isDeletedMessage'];
        this.consentUrlGeneratedSuccessfullyMessage = translations['companyBank.consentUrlGeneratedSuccessfullyMessage'];
      });
  }

  initializeObject(): void {
    if (this.currentObject == null) {
      this.currentObject = new CompanyBank(this.companyId);
    }

    if (!this.currentObject.CronExpression) {
      this.currentObject.CronExpression = '0 0 4,12 * * ?';
    }

    super.initializeObject();
  }

  handleBankChanged(bank: Bank): void {
    if (bank) {
      this.currentObject.BankName = bank.Name;
      this.currentObject.BankId = bank.BankId;
    } else {
      this.currentObject.BankName = undefined;
      this.currentObject.BankId = undefined;
    }
  }

  onSubmit(form: NgForm): void {
    if (!this.currentObject.CompanyBankId) {
      this.genericService.postObject(
        Url.CompanyBank,
        this.currentObject,
        (postedCompanyBank: CompanyBank) => {
          this.createConsentUrl(postedCompanyBank, form);
        },
        this.addedSuccessfullyMessage);
    } else {
      this.genericService.putObject(
        Url.CompanyBank,
        this.currentObject.CompanyBankId,
        this.currentObject,
        (puttedCompanyBank: CompanyBank) => {
        },
        this.updatedSuccessfullyMessage);
    }
  }

  createConsentUrl(companyBank: CompanyBank, form: NgForm): void {
    this.genericService.postObject(
      Url.CompanyBankCreateConsent.replace('{companyBankId}', companyBank.CompanyBankId.toString()),
      null,
      (consentLink: string) => {
        companyBank.ConsentLink = consentLink;
        this.handleSubmit(form);
      },
      this.consentUrlGeneratedSuccessfullyMessage);
  }
}
